import { useQuery } from '@tanstack/react-query';
import { getLoggedInWorkspace } from '@wix/ambassador-os-v1-workspace/http';
import type { Workspace } from '@wix/ambassador-os-v1-workspace/types';
import { useHttpClient } from '@wix/fe-essentials/react';
import { getIsLoggedInByCookie } from '../utils/getIsLoggedInByCookie';

export const useWorkspaceQuery = () => {
  const httpClient = useHttpClient();
  const isUserLoggedIn = getIsLoggedInByCookie();

  return useQuery<Workspace | undefined, Error>({
    queryKey: ['workspace'],
    queryFn: async (): Promise<Workspace | undefined> => {
      if (!isUserLoggedIn) {
        return undefined;
      }
      const {
        data: { workspace },
      } = await httpClient.request(getLoggedInWorkspace({}));
      return workspace;
    },
    enabled: isUserLoggedIn,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
